import { createContext } from 'react';


export const AlertRequestContext = createContext({});

export const AlertsRequestPageContext = createContext({});
